import { validationMixin } from "vuelidate";

export const vuelidate = Object.assign({}, validationMixin, {
  methods: {
    validateState(name) {
      if (!this.$v.form[name]) {
        console.error(
          `vuelidate mixin: validateState: no field with name '${name}' on form`
        );
        return null;
      }
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    hasError(name, error) {
      if (!this.$v.form[name]) {
        console.error(
          `vuelidate mixin: hasError: no field with name '${name}' on form`
        );
        return null;
      }

      // Prevent showing error when form hasn't been submitted yet
      const { $dirty } = this.$v.form[name];
      if (!$dirty) {
        return false;
      }

      if (this.$v.form[name][error] === undefined) {
        console.error(
          `vuelidate mixin: hasError: ${name} has no validation rules defined for '${error}'`
        );
        return null;
      }

      // Return specific error in specific field
      const valid = this.$v.form[name] && this.$v.form[name][error];
      return !valid;
    }
  }
});
